import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface SectionProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  background?: 'white' | 'light' | 'dark' | 'primary';
  centered?: boolean;
  id?: string;
  className?: string;
}

// Componente base sin styled-components para evitar problemas de tipado
const Section: React.FC<SectionProps> = ({
  title,
  subtitle,
  children,
  background = 'white',
  centered = false,
  id,
  className,
}) => {
  // Calcular estilos según las props
  let backgroundColor = '#ffffff'; // default white
  let textColor = '#343a40'; // default gray-dark
  
  switch (background) {
    case 'light':
      backgroundColor = '#f8f9fa';
      break;
    case 'dark':
      backgroundColor = '#343a40';
      textColor = '#ffffff';
      break;
    case 'primary':
      backgroundColor = '#007bff';
      textColor = '#ffffff';
      break;
  }
  
  const sectionStyle: React.CSSProperties = {
    padding: '5rem 1rem',
    backgroundColor,
    color: textColor
  };
  
  const containerStyle: React.CSSProperties = {
    maxWidth: '1200px',
    margin: '0 auto'
  };
  
  const headerStyle: React.CSSProperties = {
    marginBottom: '3rem',
    textAlign: centered ? 'center' : 'left'
  };
  
  const titleStyle: React.CSSProperties = {
    fontSize: '2.5rem',
    marginBottom: '1rem',
    position: 'relative',
  };
  
  const subtitleStyle: React.CSSProperties = {
    fontSize: '1.25rem',
    opacity: 0.8,
    maxWidth: '800px',
    margin: centered ? '0 auto' : '0'
  };
  
  // Elemento personalizado para el subrayado del título
  const titleUnderline: React.CSSProperties = {
    content: '',
    position: 'absolute',
    left: centered ? '50%' : '0',
    transform: centered ? 'translateX(-50%)' : 'none',
    bottom: '-0.5rem',
    width: '50px',
    height: '3px',
    backgroundColor: '#007bff'
  };
  
  return (
    <section style={sectionStyle} id={id} className={className}>
      <div style={containerStyle}>
        {(title || subtitle) && (
          <div style={headerStyle}>
            {title && (
              <h2 style={titleStyle}>
                {title}
                <div style={titleUnderline}></div>
              </h2>
            )}
            {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section; 